module.exports = __webpack_public_path__ + "img/t_es.13ab0139.jpg";